/* ─────────────────────────────────────────────────────────────
   Mid-article "Best Sellers" banner — mobile dot/scroll sync.

   This is the ONLY JavaScript in the feature. The agency's version
   of this banner was ~350 lines (MutationObserver retry loop,
   multi-selector scope probing, scroll fallbacks, runtime <style>
   injection into <head>). All of that is unnecessary: the markup,
   the styles and the insertion point are resolved server-side, so
   the only thing genuinely left to the client is reflecting scroll
   position in the dots.

   Deliberately NOT rAF-gated and not IntersectionObserver-gated:
   both stall in a background/hidden tab, which is exactly how this
   template gets QA'd (the sticky-ATC build was blocked for a
   session by precisely that). Straight-line setup on DOM ready.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function setup(banner) {
    var track = banner.querySelector('[data-mpb-track]');
    var dotWrap = banner.querySelector('[data-mpb-dots]');
    if (!track || !dotWrap) return;

    var dots = [].slice.call(dotWrap.querySelectorAll('[data-mpb-dot]'));
    var cards = [].slice.call(track.querySelectorAll('.mpb__card'));
    if (!dots.length || !cards.length) return;

    function scrolls() {
      // 2px of slack: sub-pixel layout rounding otherwise reports a
      // non-scrolling 3-up desktop row as scrollable and shows dots.
      return track.scrollWidth - track.clientWidth > 2;
    }

    function sync() {
      if (!scrolls()) {
        dotWrap.hidden = true;
        return;
      }
      dotWrap.hidden = false;
      // Cards snap to CENTRE (scroll-snap-align: center, inside an 11%
      // inline scroll-padding), so the active card is the one whose
      // centre is nearest the track's centre — comparing offsetLeft
      // against scrollLeft would mark the wrong dot at both ends.
      // Measured from real positions, not an assumed card width.
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestGap = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var gap = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - centre);
        if (gap < bestGap) { bestGap = gap; best = i; }
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (!cards[i]) return;
        track.scrollTo({
          left: cards[i].offsetLeft + cards[i].offsetWidth / 2 - track.clientWidth / 2,
          behavior: 'smooth'
        });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-mpb]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
